import logo from 'images/communities/Michigan/logo.svg'
import footerLogoOne from 'images/communities/Michigan/MAC-Logo-white_NO-tag.svg'
import footerLogoTwo from 'images/communities/Michigan/MAEIA-logo_color.svg'
import footerLogoThree from 'images/communities/Michigan/MACC-Logo-black-and-white.svg'
import footerLogoFour from 'images/communities/Michigan/MI-DOE-Logo.svg'
import dashboardHeaderImage from 'images/communities/Michigan/banner.svg'
import favicon from 'images/communities/Michigan/favicon.png'
import homeLogo from 'images/home/community-logos/michigan.png'
import loginBackgroundImg from 'images/communities/Michigan/login-background-image.svg'
import { SURVEY_QUESTIONS } from 'types'
import videoImage from 'images/map/video/michigan-video-button-image.png'

const config = {
  subdomain: 'michigan',
  name: 'Michigan',
  position: 12,
  partnerSupportEmail: 'micreativepotential@michiganassessmentconsortium.org',
  schoolSupportEmail: 'micreativepotential@michiganassessmentconsortium.org',
  artistSupportEmail: 'micreativepotential@michiganassessmentconsortium.org',
  stylesheet: 'michigan.scss',
  mapRedirectPath: '',
  organizationUrl: 'https://www.micreativepotential.org ',
  faqUrl:
    'https://drive.google.com/file/d/19otJjh-pMh-QiI89kFMje96ApF4sPcC_/view?usp=sharing',
  additionalUrls: [
    {
      src: 'https://maeia-artsednetwork.org/',
      title: 'MAEIA Resources',
    },
  ],
  mapEnabled: true,
  schoolPortalEnabled: true,
  partnerPortalEnabled: true,
  partnerProfileCompletionEnabled: true,
  schoolProfileCompletionEnabled: true,
  teachingArtistProfileCompletionEnabled: true,
  showRecentLoginOnPublicPage: true,
  portalSignInEnabled: true,
  googleLoginEnabled: true,
  partnerProgramsEnabled: true,
  dataDashboardEnabled: true,
  notificationsEnabled: true,
  educatorEnabled: false,
  partnerRegisterEnabled: true,
  id: 80,
}

// ----- Teaching Artist -----
config.teachingArtist = {
  enabled: true,
  registerEnabled: true,
  provideOwnPrograms: true,
  faqUrl:
    'https://www.canva.com/design/DAG3Li6fiwQ/J2wEBB_IA7Vm6dECRnviOw/view?utm_content=DAG3Li6fiwQ&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hfaea1380ab',
}

config.teachingArtistRegister = {
  fields: {
    firstName: {
      visible: true,
      required: true,
    },
    lastName: {
      visible: true,
      required: true,
    },
    email: {
      visible: true,
      required: true,
    },
    address: {
      visible: true,
      required: true,
    },
    yearsOfExperience: {
      visible: true,
      required: false,
    },
    description: {
      visible: true,
      required: true,
    },
    website: {
      visible: true,
      required: true,
    },
    disciplines: {
      visible: true,
      required: true,
    },
    profilePicture: {
      visible: true,
      required: false,
    },
    backgroundCheckFile: {
      visible: false,
      required: false,
    },
    pronouns: {
      visible: true,
      required: false,
    },
    demographic: {
      visible: true,
      required: false,
    },
    idealWage: {
      visible: true,
      required: false,
    },
  },
}

// Search
config.search = {
  options: {
    blockList: ['networks', 'creativeSchoolsCategory'],
  },
  map: {
    center: { lat: 44.314806, lng: -85.602389 },
    radius: 250, // in miles
  },
  schoolSearchFilters: [
    'network',
    'creativeSchoolsCategory',
    'instructorsTeaching',
    'schoolType',
    'organizationPartnersCount',
    'programsOffered',
    'disciplineInterests',
    'resourceProgramOutcomeInterests',
    'coursesOffered',
    'studentDemographics',
    'openToPartnerships',
    'region',
  ],
}

// Branding
config.defaultBranding = {
  className: 'michigan-community',
  favicon,
  mapLogo: {
    src: logo,
    alt: "Michigan Creative Potential's hompage",
    link: config.organizationUrl,
  },
  videoImpage: {
    src: videoImage,
    alt: 'Video Image',
  },
  homeLogo: {
    src: homeLogo,
    alt: 'Michigan Creative Potential',
  },
  footerLogos: [
    {
      src: footerLogoOne,
      alt: 'Michigan Assessment Consortium',
      link: 'https://www.michiganassessmentconsortium.org/',
    },
    {
      src: footerLogoTwo,
      alt: 'maeia',
      link: 'https://maeia-artsednetwork.org/',
    },
    {
      src: footerLogoThree,
      alt: 'Michigan Arts & Culture Council',
      link: 'https://www.michiganbusiness.org/industries/macc/',
    },
    {
      src: footerLogoFour,
      alt: 'Michigan Department of Education',
      link: 'https://www.michigan.gov/mde',
    },
  ],
  communityLogo: {
    src: logo,
    alt: 'Artlook Schools',
  },
  dashboardHeader: {
    src: dashboardHeaderImage,
    alt: '',
  },
  loginBackgroundImg: {
    src: loginBackgroundImg,
    alt: '',
  },
  mapHero: {
    src: dashboardHeaderImage,
    alt: '',
  },
}

// ----- DISPLAY TEXT -----

/**
 * This object overrides the display text that is defined globally with string values that are
 * specific to the organization. Mustache-esque templating is available for dynamic strings using
 * {{ insertFieldName }} for interpolation.
 */

config.displayText = {
  map: {
    title: 'artlook Map: advancing arts education in Michigan',
    searchHeader: 'Find Schools & Partners in Michigan',
    welcomeSearchHeader: 'Explore Arts Education in Michigan',
    welcomeHeader: `
      How Does artlook Help Arts Education in <span>${config.name}<span>?
    `,
    explorationHeader:
      '<h1>What can you do on artlook<sup>®</sup> Michigan</h1>',
    explorationSubTitle: 'Here are some examples...',
    welcomeMessage: `
      <div class="columns">
        <div class="column-left">
          <p>
            artlook<sup>®</sup> ${config.name} is a free online hub created to help educators in our state immerse 
            young people in powerful, personally relevant arts learning opportunities.  
          </p>
          <p>
            Developed by Ingenuity in Chicago and customized as a collaboration among local teachers, school and 
            district administrators, arts partners, and MI Creative Potential staff, artlook® provides an up-to-date 
            picture of the people, places, and programs supporting arts learning in Michigan.  
          </p>
        </div>
        <div class="column-right">
          <p>
            In addition to the public Map and Directory available on this site, artlook also enhances the way that MI 
            Creative Potential is able to provide data analysis, reporting, and specialized programs to arts educators, 
            advocates, and funders with the goal of strengthening a diverse, robust arts education system in our state.   
          </p>
          <p>
            MI Creative Potential invites additional schools and arts partners to join artlook® Michigan each year. 
            Learn more about eligibility and how to get on the map at 
            <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.
          </p>
        </div>
      </div>
    `,
    findSchoolsCard: {
      title: `Find Schools`,
      text: `
        <p>
          If you’re an arts organization or teaching artist, search for schools in need of programs that you offer. 
          Reach out!
        </p>
        <p>
          If you’re a parent looking for an arts-rich or discipline-specific school for your child, find schools that 
          provide what you’re looking for.
        </p>
      `,
    },
    findProgramsCard: {
      title: `Find Arts Programs & Organizations`,
      text: `
        <p>
          If you're a school in need of supplemental arts programs, partnerships, or resources, search for arts orgs that 
          offer the disciplines you seek. New arts ed partners are waiting to connect!
        </p>
      `,
    },
    findDataCard: {
      title: `Find Data`,
      text: `
        <p>
          If you’re an advocate for a stronger, more vibrant arts education landscape in Michigan, reach out to 
          <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>. 
          We provide data, programming, and other opportunities aimed at strengthening and expanding creative 
          opportunities for our state's students.
        </p>
      `,
    },
    justExploreCard: {
      title: `Just Explore`,
      text: `
      <p>
        The artlook<sup>®</sup> ${config.name} Map contains the most comprehensive picture of arts ed in our state- go 
        search, explore, and learn more about the arts in our schools -- as well as where we need to bring more arts to 
        more students.
      </p>
    `,
    },
    videoWelcomeTitle: `Welcome To artlook<sup>®</sup> ${config.name}`,
    videoWelcomeMessage: `
      <p>
        This (free!) publicly-available and searchable map is the only one of its kind in ${config.name} to capture 
        information on arts education from schools, arts organizations, and teaching artists. Using the Search 
        function above, you can explore the arts ed programs and resources available to students in schools and via 
        partners throughout the region.
      <p>
        The Map and Directory provide an up-to-date picture of what’s happening in arts ed and where, as well as 
        contact info to connect directly to these schools and arts organizations. GO EXPLORE & CONNECT to bring more 
        arts to more students!
      </p>
    `,
    videoModal: {
      width: '560',
      height: '315',
      srcUrl: 'https://www.youtube.com/embed/ZV2lhRt1cSM?controls=0',
      iframeTitle: 'Michigan artlook map welcome video',
    },
    footer: {
      learnMoreAboutArtlook: 'Learn more about artlook<sup>®</sup>',
      contact: "We'd love to hear from you",
    },
    metricScore: {
      title: 'Creative Schools Certification',
      message: `
        The Creative Schools Certification is at the core of the CPS
        Arts Education Plan. It is a summary measure of the quality
        of arts education available in each school, and therefore
        functions as a decision-making roadmap for stakeholders
        working to expand the arts in schools.
      `,
      basedOnSchoolYear:
        ' The Certification information here is based on the {{ schoolYearNumber }} school year.',
    },
  },
  surveyCompletionModal: `
    <h2>Survey Complete!</h2>
    <br />
    <p>Thank you for completing this year's survey! Your responses help us paint a more comprehensive picture of arts education and can help us connect public schools such as yourselves with quality arts programs. You can download a copy of your survey responses on the survey page.</p>
    <br />
    <p><b>Next up: Give your Profile a quick refresh! Update your current year data to make sure everything's spot-on. The more accurate your info, the easier it is to connect with new partners and get discovered by the right ones.</b></p>
  `,
  tagline: 'Together we can advance arts education in Michigan.',
  partnerPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Michigan</em> is YOUR portal to supplement arts education in K-12 schools.</h3>
        <p>Use <em>artlook<sup>®</sup> Michigan</em> to connect to schools seeking collaboration with arts education partners in dance, media arts, music, theatre, and visual arts.</p>
        <p>
          <strong>To get started, follow the links in the boxes below to share your organization's program and school partnership information. Make sure to complete all sections of your profile.</strong>
        </p>
        <p> Please reach out with questions: <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener noreferrer">${config.partnerSupportEmail}</a>.</p>
      `,
    },
    profile: {
      contacts: {
        executiveDirector: 'Executive Director/ CEO/ President',
      },
    },
  },
  schoolPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Michigan</em> is YOUR portal to supplement arts education in K-12 schools.</h3>
        <p>
          Use <em>artlook<sup>®</sup> Michigan</em> to connect to teaching artists and community arts education providers available to collaborate in dance, media arts, music, theatre, and visual arts education.
        </p>
        <p>
          <strong>
            To get started, complete both steps below: Update Your School Profile to share your partnership interests for the current school year, and Complete the Annual Survey (once it goes live) to share information about your school's arts education offerings from the previous school year.
          </strong>
        </p>
        <p> Please reach out with questions: <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.</p>

      `,
    },
    summary: {
      artsLiaison: {
        header: 'School Arts Liaison',
        tooltip:
          'The Arts Liaison advocates for and facilitates arts education by serving as the primary communicator between their school, arts organizations, and the community. The Arts Liaison acts as the artlook administrator for profile upkeep and the annual survey, ensuring access to arts-related information, supporting artistic initiatives, and working to enhance arts programming in their schools.',
      },
      partnerProgramTypes: {
        header:
          'What types of partner programs would you be interested in having for your school? Check all that apply.',
      },
    },
  },
  educatorPortal: {
    welcomdMessage: ``,
  },
  survey: {
    getStarted: `
      <h2>Welcome to the MI Creative Schools survey!</h2>
      <p>You will add your school's information to share about your arts education instruction, staffing, community partnerships, and resource needs.</p>
      <p>Please save frequently to avoid losing data. You can complete your survey in multiple sessions; saving as you respond to each question will allow you to return to edit your survey before submitting.</p>
      <p>Your data, collected together with schools from across the state, will advance access to quality arts education in Michigan's schools.</p>
    `,
    staffingQuestion: {
      modalMessage: `
        <p>
        <strong>Note on instructors:</strong> Restrict the list of instructors in your school to those teaching an arts course during the school day. Note that district-run/district-managed schools require arts instructors to hold an ISBE certification or endorsement in one of the four state-recognized disciplines (visual arts, music, theater, and/or dance). Charter schools, contract schools, and Pre-K-only schools do not have this requirement. The media arts discipline does not have an ISBE certification/endorsement; these instructors should be listed as well.
        </p>
        <p>
        <strong>Note on part/full-time status:</strong> Please select Full Time if a teacher had full-time status for the entire school year. If a teacher was part-time for all or part of the year, or full-time for only part of the year, please select Part Time.
        </p>
        <p>
        <strong>Note on disciplines:</strong> The Primary Focus of each instructor is required. You may optionally list a Secondary Focus as well. Please also select the “Classroom/non-arts teacher?” button if the instructor is not primarily an arts instructor (e.g., non-arts, general education teacher teaching arts courses).
        </p>
        `,
      displayOptions: {
        showClassNumber: true,
      },
    },
    instructorQuestion: {
      displayOptions: {
        showInstructorEmail: true,
      },
    },
    scholarshipQuestion: {
      displayOptions: {
        showExample: true,
      },
    },
    staffingModal: ``,
    courses: {
      classMoniker: '',
      coursesNote: ``,
      minutesNotes: ``,
      instructionalDepthNote: ``,
    },
    percentAccess: {
      question: '',
      description: '',
      courseEnrollmentLabel: '',
      error: '',
    },
    obstaclesSelect: {
      question: '',
    },
    terms: ``,
  },
  artistPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Welcome to artlook – A Home for Teaching Artists!</h3>
        <p>
          We're excited to have you join our vibrant community of teaching artists, educators, and organizations passionate about arts education. Whether you're here to showcase your talents, connect with schools and partners, or discover new opportunities, this platform is designed to support your journey
        </p>
        <p>
          Start by building your profile, sharing your experience, and exploring collaborations. Together, we can inspire creativity and make a lasting impact through the arts.
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.artistSupportEmail}" target="_blank" rel="noopener noreferrer">${config.artistSupportEmail}</a>.
        </p>
      `,
    },
  },
  learningHub: {
    welcomeMessage: `
        <h2>Welcome to the artlook Learning Hub!</h2>
        <p>
          This platform is your central space for learning, collaboration, and
          growth. Whether you're exploring new skills, completing professional
          training, or sharing creative ideas, this LMS is designed to make your
          learning experience engaging and easy to navigate.
        </p>
        <p>
          If you have any questions or need assistance, please contact
          <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.
        </p>
      `,
  },
}

// ----- SURVEY QUESTIONS CONFIG -----
// Confirm with the Community that these are the correctly enabled Survey Questions

const {
  APPROACHES,
  GOVERNANCE,
  OBSTACLES_SELECT,
  OBSTACLES_DESCRIBE,
  OBSTACLES_OVERCOME,
  DISTRICT_SPENDING,
  COMMUNITY_ENGAGEMENTS,
} = SURVEY_QUESTIONS

config.surveyQuestions = {
  approaches: APPROACHES.OPTIONS.GENERAL,
  governance: GOVERNANCE.OPTIONS.GENERAL,
  obstaclesSelect: OBSTACLES_SELECT.OPTIONS.GENERAL,
  obstaclesDescribe: OBSTACLES_DESCRIBE.OPTIONS.GENERAL,
  obstaclesOvercome: OBSTACLES_OVERCOME.OPTIONS.GENERAL,
  districtSpending: DISTRICT_SPENDING.OPTIONS.GENERAL,
  communityEngagement: COMMUNITY_ENGAGEMENTS.OPTIONS.GENERAL,
}

export default config
